module.exports = __webpack_public_path__ + "img/Rocket Innovation Studios.a683084c.png";